import React, { Component } from 'react';
import anime from 'animejs';
import { message } from "antd";
import Footer from '../../components/Footer';
import Nav from '../../components/Nav/index';
import Loader from '../../components/loader';
import './index.less';
import Axios from "../../axios";
import Utils from '../../utils/utils'

export default class Home extends Component {
    state = {
        bgImg: '',
        isLoading: true
    }
    componentWillMount() {
        this.listRequest();//获取背景图片
    }
    animation = () => {
        var textWrapper = document.querySelector('.text-wrapper');
        textWrapper.innerHTML = textWrapper.textContent.replace(/([^\x00-\x80]|\w)/g, "<span class='letter'>$&</span>");
        anime.timeline({ loop: 1 })
            .add({
                targets: '.letter',
                translateY: ["-1.1em", 0],
                translateZ: 0,
                duration: 1000,
                delay: function (el, i) {
                    return 50 * i;
                }
            }).add({
            targets: '.ml6',
            opacity: 1,
            duration: 1300,
            easing: "easeOutExpo",
            delay: 1200
        });
    }
    /*列表背景图片*/
    listRequest = () => {
        let _this = this;
        this.setState({
            isLoading: true,
        })
        var params = { key: "IndexBanner" };
        Axios.get({
            block: '/api/option',
            url: '/queryOption',
            params: params,
        }).then((data) => {
            console.log(data)
            if (data.code === 0) {
                let items = data.data;
                this.setState({
                    bgImg: Utils.getUrl(items)
                })
            } else {
                message.error(data.msg);
            }
            setTimeout(function () {
                _this.setState({
                    isLoading: false
                })
            },1000)
            this.setState({
                // isLoading: false
            })
            // this.animation();
        }).catch((error) => {
            console.log(error);
        })
    };
    render() {
        const { bgImg, isLoading } = this.state;
        return (
            <div style={{overflow:'hidden'}}>
                {
                    isLoading ? <Loader cTitle="首页" eTitle="HOME" />
                        : <div>
                            <div className="home-box" style={{ backgroundImage: "url(" + bgImg + ")" }}>
                            {/*<Nav/>*/}
                            </div>
                            <div className="contain">
                                <div className="title">
                                    <h4>
                                        HOTEL ROOMS
                                    </h4>
                                    <p>lntelligent Control</p>
                                </div>
                            </div>
                            <Footer/>
                        </div>
                }
            </div>
        )
    }

}
